import { PartnersPage } from './partnersPage.js';
import { PartnersSinglePage } from './partnersSinglePage.js';
import { EventsPage } from './eventsPage.js';
import { SearchPage } from './searchPage.js';
import { HubPage } from './hubPage.js';
import { DossierPage } from './dossierPage.js';

export const PAGE_MODULES = [
    HubPage,
    DossierPage,
    PartnersPage,
    PartnersSinglePage,
    EventsPage,
    SearchPage,
];
